
import { Box, styled } from '@mui/material';

import Slide from './Slide';

const Component = styled(Box)`
    display: flex;
    
`;

const LeftComponent = styled(Box)(({ theme }) => ({
    width: '83%',
    [theme.breakpoints.down('md')]: {
         width: '100%'
    }    
}));



const RightComponent = styled(Box)(({ theme }) => ({
    background: '#FFFFFF',
    width: '17%',
    marginLeft: 10,
    marginTop: 10,
    padding: 5,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
        display: 'none'
    },
    '& img': {
        padding: '10px 5px 5px 5px', 
        
    }
}));


const MidSlide = ({ products, title, timer }) => {
    const adURL = 'https://rukminim1.flixcart.com/flap/464/708/image/633789f7def60050.jpg?q=70';

    return (
        <Component>
            <LeftComponent>
                <Slide 
                    products={products}
                    title='Deals of the Day'
                    timer={true} 
                    multi={true} 
                />
            </LeftComponent>
            <RightComponent>
                <img src={adURL} alt="ad" style={{width: 220}}/>
            </RightComponent>
        </Component>
    )
}

export default MidSlide;